import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import withLoader from 'components/organisms/withLoader';
import { scrollToErrorIfExist, showResult } from 'utils';
import Button from 'components/atoms/button';
import { Formik, Form } from 'formik';
import { Card, CardBody, Table } from 'reactstrap';
import forms from 'constants/forms';
import { isAgencyDoctor, isPractice } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import validationSchema from 'components/organisms/adminPanels/clinics/validationSchema';
import thresholdValidationSchema from 'components/organisms/adminPanels/clinics/threshold/validationSchema';
import requestBodyGenerator from 'components/organisms/adminPanels/clinics/requestBodyGenerator';
import Contact from 'components/organisms/adminPanels/clinics/components/contact';
import Address from 'components/organisms/adminPanels/clinics/components/address';
import ClinicDetails from 'components/organisms/adminPanels/clinics/components/clinicDetails';
import Registration from 'components/organisms/adminPanels/clinics/components/registration';
import Threshold from 'components/organisms/adminPanels/clinics/components/threshold';
import Representatives from 'components/organisms/adminPanels/clinics/components/representatives';
import Agency from 'components/organisms/adminPanels/clinics/components/agency';
import ParentClinic from 'components/organisms/adminPanels/clinics/components/parentClinic';
import RunBook from 'components/organisms/adminPanels/clinics/components/runBook';

const AddClinic = () => {
  const formRegistration = [...forms.adminPanelsClinic.clinicAdd.registration];
  const { agencies, userType } = useUser();
  const history = useHistory();
  const {
    adminPanelClinics: { createClinic },
  } = useDispatch();
  const { clinic, threshold } = useSelector((state) => state.adminPanelClinics);
  const initialValues = { ...clinic, threshold };
  if (isAgencyDoctor(userType)) {
    initialValues.agencyGuid = agencies[0].guid;
  }

  const {
    getThreshold: thresholdLoading,
    getClinic: clinicDetailsLoading,
    getRepresentatives: representativesLoading,
    getAgencies: agenciesLoading,
    createClinic: submitLoading,
  } = useSelector((state) => state.loading.effects.adminPanelClinics);

  const submitHandler = async (clinicRequest) => {
    const body = requestBodyGenerator(clinicRequest);
    const { data, error } = await createClinic(body);
    if (error) return showResult(error);
    if (data) {
      showResult();
      history.push(`/admin/clinic/${data.guid}`);
    }
  };
  return (
    <div className="admin-patient">
      {withLoader(
        clinicDetailsLoading ||
          thresholdLoading ||
          representativesLoading ||
          agenciesLoading,
        <>
          {clinic && (
            <Card className="card-border">
              <CardBody>
                <div className="admin-patient-header">
                  <span>Add Clinic</span>
                </div>
                <Formik
                  onSubmit={submitHandler}
                  initialValues={initialValues}
                  validationSchema={validationSchema(thresholdValidationSchema)}
                >
                  {({ errors, values, setFieldValue }) => (
                    <Form>
                      <div className="admin-patient-edit-form">
                        <Table>
                          <tbody>
                            <tr>
                              <td>
                                <Contact errors={errors} />
                              </td>
                              <td>
                                <Address errors={errors} />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Registration
                                  formRegistration={formRegistration}
                                  errors={errors}
                                />
                                <Representatives
                                  clinic={clinic}
                                  errors={errors}
                                />
                                {isAgencyDoctor(userType) && (
                                  <Agency agencies={agencies} errors={errors} />
                                )}
                                {!isPractice(userType) && (
                                  <ParentClinic
                                    agencyGuid={values?.agencyGuid}
                                    errors={errors}
                                  />
                                )}
                              </td>
                              <td>
                                <ClinicDetails
                                  type="clinicAdd"
                                  errors={errors}
                                />
                                <RunBook
                                  errors={errors}
                                  values={values}
                                  setFieldValue={setFieldValue}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                {values.threshold && (
                                  <Threshold
                                    values={values?.threshold}
                                    idPrefix="threshold."
                                    errors={errors?.threshold}
                                  />
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div className="text-center">
                        <Button
                          disabled={submitLoading && errors}
                          type="submit"
                          text="Save"
                          handleClick={scrollToErrorIfExist}
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          )}
        </>,
      )}
    </div>
  );
};

export default AddClinic;
